import { render, staticRenderFns } from "./aftersalevideo.vue?vue&type=template&id=6607a0c8&scoped=true"
import script from "./aftersalevideo.vue?vue&type=script&lang=js"
export * from "./aftersalevideo.vue?vue&type=script&lang=js"
import style0 from "./aftersalevideo.vue?vue&type=style&index=0&id=6607a0c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6607a0c8",
  null
  
)

export default component.exports